var exports = {
  "ci": "TextareaInput.module__textareaContainer___M0F2c2",
  "yF": "TextareaInput.module__divider___M0F2c2",
  "Ot": "TextareaInput.module__textareaOuter___M0F2c2",
  "WJ": "TextareaInput.module__collapsibleSection___M0F2c2",
  "qp": "TextareaInput.module__inputSection___M0F2c2",
  "aq": "TextareaInput.module__textareaOuterMobile___M0F2c2",
  "AE": "TextareaInput.module__mainWrapperDense___M0F2c2",
  "bx": "TextareaInput.module__mainWrapperEditing___M0F2c2",
  "m$": "TextareaInput.module__uploadButtonColumn___M0F2c2",
  "D4": "TextareaInput.module__sideButtonPadding___M0F2c2",
  "Qh": "TextareaInput.module__plusButtonAboveBackdrop___M0F2c2",
  "Sr": "TextareaInput.module__contentAreaDense___M0F2c2",
  "h": "TextareaInput.module__contentAreaEditing___M0F2c2",
  "l7": "TextareaInput.module__buttonContainerDense___M0F2c2",
  "ae": "TextareaInput.module__buttonContainerEditing___M0F2c2",
  "ou": "TextareaInput.module__textareaOuterRow___M0F2c2",
  "o_": "TextareaInput.module__textareaOuterBare___M0F2c2",
  "nw": "TextareaInput.module__mainWrapperBare___M0F2c2",
};

module.exports = exports;
